import { render, staticRenderFns } from "./Adware.vue?vue&type=template&id=3c27fe4a&"
import script from "./Adware.vue?vue&type=script&lang=js&"
export * from "./Adware.vue?vue&type=script&lang=js&"
import style0 from "./Adware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports